<template>
  <FiltersProvider
    :filters="filters.items"
    :options="filters.options"
    :dynamic-options="filters.dynamicOptions"
    :models="filters.models"
    v-slot="{ filters: items, options, dynamicOptions, selectedList, reset, resetOne }"
  >
    <ModalWindow
      :title="modalTitle"
      v-on="modalListeners"
    >
      <FiltersSubmitScreen v-if="modalView === 'filters'">
        <template #default>
          <SectionBox
            v-if="!visitor.isGuest && savedFilters"
            shadow="none"
          >
            <SavedFiltersCounter @click="modalView = 'savedFilters'" />
          </SectionBox>

          <SectionBox v-if="hasSuggestedFilters" shadow="none">
            <BasicSection>
              <ContentSection title="Фильтры на основе вашего профиля" appearance="form-section">
                <SelectedFilters :items="suggestedFilters.selectedList" />
              </ContentSection>
            </BasicSection>
          </SectionBox>

          <SectionBox v-if="selectedList.length !== 0" shadow="none">
            <BasicSection>
              <ContentSection title="Выбранные фильтры" appearance="form-section">
                <SectionGroup>
                  <SelectedFilters
                    :items="selectedList"
                    @remove="resetOne($event)"
                  />
                  <FiltersControls
                    v-if="savedFilters"
                    @reset="reset"
                    @save="$emit('saveFilters', items)"
                  />
                  <FiltersControls
                    v-else
                    @reset="reset"
                  />
                </SectionGroup>
              </ContentSection>
            </BasicSection>
          </SectionBox>
        </template>

        <template #filters>
          <slot
            name="filters"
            :filters="items"
            :options="options"
            :dynamicOptions="dynamicOptions"
          />
        </template>

        <template #submit-button>
          <slot
            name="submit-button"
            :filters="items"
            :dynamic-options="dynamicOptions"
          />
        </template>
      </FiltersSubmitScreen>

      <SavedFiltersScreen
        v-else
        :description="savedFiltersDescription"
        @loadSavedFilter="$emit('loadSavedFilter', $event)"
        @primaryActionClick="$emit('close')"
      />
    </ModalWindow>
  </FiltersProvider>
</template>

<script>
  import FiltersControls from 'src/components/filters/FiltersControls/FiltersControls.vue';
  import FiltersProvider from 'src/components/filters/FiltersProvider/FiltersProvider.vue';
  import FiltersSubmitScreen from 'src/components/filters/FiltersSubmitScreen/FiltersSubmitScreen.vue';
  import SavedFiltersCounter from 'src/components/filters/SavedFiltersCounter/SavedFiltersCounter.vue';
  import SavedFiltersScreen from 'src/components/filters/SavedFiltersScreen/SavedFiltersScreen.vue';
  import SelectedFilters from 'src/components/filters/SelectedFilters/SelectedFilters.vue';
  import ModalWindow from 'src/components/overlays/ModalWindow/ModalWindow.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

  const modals = {
    filters: 'Фильтры',
    savedFilters: 'Сохранённые фильтры',
  };

  export default {
    name: 'FiltersModal',
    components: {
      FiltersControls,
      SectionGroup,
      SelectedFilters,
      ContentSection,
      BasicSection,
      SavedFiltersCounter,
      SectionBox,
      FiltersSubmitScreen,
      SavedFiltersScreen,
      ModalWindow,
      FiltersProvider
    },
    inject: {
      filters: 'filters',
      suggestedFilters: {
        default: null
      },
      savedFilters: {
        default: null,
      },
      visitor: 'visitor'
    },
    props: {
      savedFiltersDescription: String,
    },
    data() {
      return {
        modalView: 'filters'
      }
    },
    computed: {
      modalListeners() {
        const listeners = { close: () => { this.$emit('close'); } };
        if (this.savedFilters && this.modalView !== 'filters') {
          listeners.back = () => { this.modalView = 'filters'; };
        }
        return listeners;
      },
      modalTitle() {
        return modals[this.modalView];
      },
      hasSuggestedFilters() {
        return this.suggestedFilters && this.suggestedFilters.selectedList.length !== 0;
      }
    }
  }
</script>